declare global {
  interface Window { env: any }
}

window.env = window.env || {}

export default (() => {
  /** polyfill to generate the window.env config */
  window.env = {
    IS_PROD: window.location.hostname.includes('provider-portal') && !window.location.hostname.includes('qual.') && !window.location.hostname.includes('dev.') && !window.location.hostname.includes('train.'),
    IS_QUAL: window.location.hostname.includes('qual.'),
    IS_DEV: window.location.hostname.includes('dev.'),
    IS_TRAIN: window.location.hostname.includes('train.'),
    IS_LOCAL: window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1'),
  }
})()
